import React, {useEffect, useState, Fragment} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useForm, Controller} from 'react-hook-form';
import {downloadGstPdf} from '@ibibo/myaccount-reducer';
import {numberWithCommas} from '../../../../../../utils/formatPrice';
import {DownloadButton} from '../../../../common/Form/Button/Button';
import {
  CommEarning,
  CommEarningLft,
  CommEarningRht,
  Info,
  PrcDtl,
  PrcBreakupDiv,
  FormContainer,
  LabelText,
  InputBox,
} from './CommissionEarning.styles';
import CommissionEarningLoader from './CommissionEarningLoader';
import DateRangePicker from '../../../../common/Form/DateRangePicker/DateRangePicker';

const CommissionEarning = ({data, commisionEarningData, sendTrackingDataToSdk}) => {
  const dispatch = useDispatch();
  const dateTruthFlag: boolean = true;
  const dateFalseFlag: boolean = false;
  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    formState: {isDirty},
  } = useForm();

  const {
    commission_earning: {
      left_section: {header, commission_amount, commission_breakup, footer},
      right_section: {download_invoice, invoice_input, order},
    },
  } = commisionEarningData;

  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    const url = download_invoice?.api?.url;
    if (url) {
      const urlParams = new URLSearchParams(url);
      setEndDate(urlParams.get('end_date'));
      reset();
    }
  }, [download_invoice?.api?.url]);

  const downloadInvoiceHandler = data => {
    let url = download_invoice?.api?.url + '&invoice_no=' + data?.gstNumber;
    if (data?.invoiceDate) {
      url = url + '&invoice_date=' + data?.invoiceDate;
    }
    window.open(url, '_blank');
    sendTrackingDataToSdk?.(
      {
        event_detail: {
          event_name: 'click',
          event_type: 'user_action',
          event_value: 'Download Invoice Clicked',
        },
      },
      'GST_INVOICE_REPORT',
    );
  };

  const getComponentByOrder = componentName => {
    switch (componentName) {
      case 'invoice_input':
        return (
          <FormContainer>
            <div>
              <LabelText>{invoice_input?.title}</LabelText>{' '}
              <InputBox
                placeholder={invoice_input?.placeholder}
                //onChange={e => setGstNumber(e.target.value)}
                type="text"
                maxLength={16}
                {...register('gstNumber', {
                  required: true,
                  pattern: /[^@#$%^&*()_+=]+/,
                  onChange: e => {
                    const value = e.target.value;
                    const sanitizedValue = value.replace(/[ &@#$%^*()_+=]/g, '');
                    setValue('gstNumber', sanitizedValue);
                  },
                })}
              ></InputBox>{' '}
            </div>
            <Controller
              control={control}
              name={'invoiceDate'}
              render={({field: {onChange, onBlur, value}}) => (
                <DateRangePicker
                  ref={null}
                  singleDate={dateTruthFlag}
                  startLabel={'Select Invoice Date'}
                  startValue={value}
                  changeHandler={onChange}
                  isMandatory={dateFalseFlag}
                  name="invoiceDate"
                  {...register('invoiceDate')}
                  ref={null}
                  hidePreviousDate={dateTruthFlag}
                  endDate={endDate}
                  //readOnly={false}
                />
              )}
            />
          </FormContainer>
        );

      case 'download_invoice':
        return (
          <DownloadButton isActive={isDirty} type="submit">
            {download_invoice?.title}
          </DownloadButton>
        );

      default:
        return null;
    }
  };

  return (
    <CommEarning isLoading={header !== ''}>
      {header === '' ? (
        <CommissionEarningLoader />
      ) : (
        <React.Fragment>
          <CommEarningLft>
            {header && (
              <h4 className="fz16 latoBold blackText flex hCenter mb8">
                {header?.title}{' '}
                {header?.sub_title && (
                  <span className="fs12 grey latoRegular ml5">{header?.sub_title}</span>
                )}
              </h4>
            )}
            {commission_amount && (
              <p className="fs32 latoBlack blackText mb5">
                ₹{numberWithCommas(commission_amount?.title)}
              </p>
            )}
            {commission_breakup?.length && (
              <PrcBreakupDiv>
                {commission_breakup.map((item, idx) => {
                  return (
                    <PrcDtl key={idx}>
                      {item?.title}
                      {' - '}
                      <span>
                        ₹{numberWithCommas(item?.amount)}
                        {idx !== commission_breakup?.length - 1 ? `,` : ``}
                      </span>
                    </PrcDtl>
                  );
                })}
              </PrcBreakupDiv>
            )}
            {footer && <Info>{footer?.title}</Info>}
          </CommEarningLft>
          <CommEarningRht>
            {order?.length &&
              order.map((item, idx) => {
                return (
                  <Fragment key={idx}>
                    {
                      <form onSubmit={handleSubmit(downloadInvoiceHandler)}>
                        {getComponentByOrder(item)}
                      </form>
                    }
                  </Fragment>
                );
              })}
          </CommEarningRht>
        </React.Fragment>
      )}
    </CommEarning>
  );
};

export default CommissionEarning;
